import { ws } from "../../../utils/common";

export const getFutureProgramWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "calendar/future?events=true",
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};
